import { render, staticRenderFns } from "./JobMessage.vue?vue&type=template&id=0574f79d&"
import script from "./JobMessage.vue?vue&type=script&lang=js&"
export * from "./JobMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports